module.exports = ".value-display .value.modified > *:after {\n  color: darkblue;\n  content: \"*\";\n  font-size: 0.875em;\n  margin-top: -1em;\n}\n.needed {\n  font-size: 0.875em;\n  border-top: 1px solid #777;\n  color: #777;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/value-display/xp-value-display.component.less
// module id = ./src/app/shared/value-display/xp-value-display.component.less
// module chunks = main